module.exports = __webpack_public_path__ + "img/stopwatch.98980fe0.svg";